module.exports = __webpack_public_path__ + "static/media/top-logo-902-ja-1.6bc7c6ad.png";